import styles from '../style.module.scss'
import { throttle } from 'throttle-debounce'

export function mobileOnScroll(el: HTMLElement, closeButton: HTMLElement) {
    el.classList.add(styles.mobileIsNotScrollPlayer)
    const originalTopOffset = el.getBoundingClientRect().top + window.scrollY
    const delay = 5

    function updatePlayerClass() {
        const scrollPosition = window.scrollY
        el.parentElement?.appendChild(closeButton)

        if (scrollPosition > originalTopOffset) {
            el.classList.remove(styles.mobileIsNotScrollPlayer)
            el.classList.add(styles.mobileIsScrollPlayer)
            closeButton.classList.remove(styles.closeHidden)
            closeButton.classList.add(styles.closeMobile)
        } else {
            el.classList.remove(styles.mobileIsScrollPlayer)
            el.classList.add(styles.mobileIsNotScrollPlayer)
            closeButton.classList.remove(styles.closeMobile)
            closeButton.classList.add(styles.closeHidden)
        }
    }

    const throttledUpdatePlayerClass = throttle(delay, updatePlayerClass)

    document.addEventListener('scroll', throttledUpdatePlayerClass)

    closeButton.addEventListener('click', () => {
        el.classList.remove(styles.mobileIsScrollPlayer)
        el.classList.add(styles.mobileIsNotScrollPlayer)
        closeButton.remove()
        document.removeEventListener('scroll', throttledUpdatePlayerClass)
    })
}
